export default __webpack_public_path__ + "addReport.html";